import React from 'react';
import './eventCardSkeleton.css';

/**
 * Skeleton loader component that mimics the shape of an event card.
 * Used during loading states for better perceived performance.
 */
const EventCardSkeleton = () => {
  return (
    <div className="col-lg-4 col-md-6">
      <div className="skeleton-card">
        <div className="skeleton-image"></div>
        <div className="skeleton-content">
          <div className="skeleton-date"></div>
          <div className="skeleton-title"></div>
          <div className="skeleton-info"></div>
          <div className="skeleton-info skeleton-info-short"></div>
          <div className="skeleton-footer">
            <div className="skeleton-btn"></div>
            <div className="skeleton-icon"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCardSkeleton;
